export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColorPresets: 'purple',
  themeLayout: 'horizontal',
  themeStretch: false,
};

export const ROLES = {
  YFC_ADMIN: 'YFC_ADMIN',
  FACILITY_ADMIN: 'FACILITY_ADMIN',
  VENDOR_ADMIN: 'VENDOR_ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
  FRANCHISE_REGION_ADMIN: 'FRANCHISE_REGION_ADMIN',
  CHALLENGE_ADMIN: 'CHALLENGE_ADMIN',
};

export const ROLES_KEYS = {
  SUPER_ADMIN: 0,
  YFC_ADMIN: 1,
  FRANCHISE_REGION_ADMIN: 2,
  FACILITY_ADMIN: 3,
  VENDOR_ADMIN: 4,
  CHALLENGE_ADMIN: 5,
};
